import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import { Blueprint } from '@ynomia/core/dist/project/blueprint';
import { ActionFromPayloadMap } from '../config/types';
import ConfigurationReducer from '../reducers/configuration';

export type ConfigurationStateType = {
  changes: Blueprint | null
  isUpdating: boolean
  isSyncing: boolean
  isCloning: boolean
  blueprintUpdate: Blueprint | null
  blueprintSync: Blueprint | null
  blueprintSyncPlan: Blueprint | null
  isFetchingBlueprint: boolean
};

const initialState: ConfigurationStateType = {
  changes: null,
  isUpdating: false,
  isSyncing: false,
  isCloning: false,
  blueprintUpdate: null,
  blueprintSync: null,
  blueprintSyncPlan: null,
  isFetchingBlueprint: false,
};

export type ConfigurationActionPayloadMap = {
  SET_CHANGES: Blueprint;
  RESET_CHANGES: string;
  RESET_ALL_CHANGES: undefined;
  SET_BLUEPRINT_UPDATE: Blueprint;
  SET_BLUEPRINT_SYNC: Blueprint;
  SET_BLUEPRINT_SYNC_PLAN: Blueprint;
  SET_CHANGES_BY_KEY: { key: string; blueprintUpdate: Blueprint };
  RESET_BLUEPRINT: undefined;
  SET_IS_UPDATING: boolean;
  SET_IS_SYNCING: boolean;
  SET_IS_CLONING: boolean;
  SET_IS_FETCHING_BLUEPRINT: boolean;
};

export type ConfigurationAction = ActionFromPayloadMap<ConfigurationActionPayloadMap>;

export const ConfigurationContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<ConfigurationAction>,
});

export const useConfiguration = (): [
  ConfigurationStateType, React.Dispatch<ConfigurationAction>,
] => {
  const { state, dispatch } = useContext(ConfigurationContext);
  return [state, dispatch];
};

export const ConfigurationProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(ConfigurationReducer, initialState);

  return (
    <ConfigurationContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </ConfigurationContext.Provider>
  );
};
